<template>
    <div>
        <v-rect :config="config" @click="onClick"  ref="arcFaceTwo"></v-rect>
    </div>

</template>

<script>
export default {
    name: "faceTwo",
    props:['config', 'teeth','apliedFill','layerVisible'],
    methods : {
        onClick(){
            
            if (this.config.fill === "transparent") {
                this.config.fill = "red";
                this.$emit('selected', {
                    faceCode: 'F2',
                    dentNumber: this.teeth.number
                });
            } else if (this.config.fill === "red") {
                this.config.fill = "transparent";
                this.$emit('deselected', {
                    faceCode: 'F2',
                    dentNumber: this.teeth.number
                });
            }

            console.log(this.$refs.arcFaceTwo._props.config)
        }
    },
    computed: {
        faceFill() {
            if (this.apliedFill.length > 0) {
                return 'red';
            } else {
                return 'transparent';
            }
        }
    },
    watch: {
        faceFill: {
            handler(newValue) {
                this.config.fill = newValue;
            },
            immediate: true
        },
    }
};
</script>
